import { Image } from 'react-native'

import { useNavigation } from '@zet/common/hooks/useNavigation'
import { B6 } from '@zet/design-system'
import { colors as zetColors } from '@zet/design-system'
import Pressable from '@zet/design-system/pressable'
import useBrandStore from '@zet/feature-brands/store/brands'
import { LinearGradient } from 'expo-linear-gradient'
import { styled } from 'nativewind'

const BrandCardContainer = styled(
  LinearGradient,
  `h-[85] w-[150] pl-3  rounded-md justify-center mr-3`
)

export default function BrandCard({ item, index }) {
  const {
    cardBackground: colors,
    logo: imageURI,
    categoryName,
    partnerId,
  } = item
  const { navigate } = useNavigation()
  const { setHandleResetPincode } = useBrandStore()
  return (
    <Pressable
      onPress={() => {
        navigate('BrandDetails', {
          brandDetails: true,
          brandId: partnerId,
          routeName: 'category',
        })
        setHandleResetPincode(true)
      }}
    >
      <BrandCardContainer
        colors={
          colors?.length > 1
            ? colors
            : colors?.length === 1 && !colors?.includes('')
            ? [...colors, ...colors]
            : [zetColors.primary[10], zetColors.primary[10]]
        }
        start={{
          x: 0,
          y: 0,
        }}
        end={{
          x: 0.5,
          y: 1,
        }}
        locations={[0, 1]}
        className={'mt-2'}
      >
        <Image
          source={{
            uri: imageURI,
          }}
          resizeMode="contain"
          style={{ width: 120, height: 60, alignSelf: 'center' }}
        />
        <B6 className="mb-2 pl-2 text-left">{categoryName}</B6>
      </BrandCardContainer>
    </Pressable>
  )
}
